import {
  ApartmentOutlined,
  BlockOutlined,
  CalculatorOutlined,
  CalendarOutlined,
  CheckCircleOutlined,
  CheckSquareOutlined,
  ClockCircleOutlined,
  FileTextOutlined,
  FontSizeOutlined,
  NumberOutlined,
  PaperClipOutlined,
} from '@ant-design/icons';
import React from 'react';

const FieldIcon = ({ fieldType }) => {
  const iconTypes = {
    TEXT: <FontSizeOutlined />,
    MULTI_LINE_TEXT: <FileTextOutlined />,
    NUMERIC: <NumberOutlined />,
    OPTIONS: <CheckCircleOutlined />,
    CHECKBOXES: <CheckSquareOutlined />,
    DATE: <CalendarOutlined />,
    TIME: <ClockCircleOutlined />,
    ATTACHMENT: <PaperClipOutlined />,
    CALCULATION: <CalculatorOutlined />,
    EQC: <BlockOutlined />,
    NOMENCLATURE: <ApartmentOutlined />,
  };

  return iconTypes[fieldType];
};

export default FieldIcon;
